import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import {
  Select, Option, OptGroup, TextDropdownSelect
} from 'barnyard/components';
import { categoriesFetch } from '../actions';
import { getGroupedCategories } from '../selectors';


class CategorySelect extends Component {
  componentDidMount() {
    if (_.isEmpty(this.props.categories)) {
      this.props.categoryFetchAction();
    }
  }

  renderChildren() {
    const {
      parentOnly,
      categories
    } = this.props;

    if (parentOnly) {
      return (
        _.map(
          categories, group => (
            _.map(group.categories, cat => (
              <Option value={cat.id} key={cat.id} name={cat.name}>
                {cat.name}
              </Option>
            ))
          )
        )
      );
    }

    return (
      _.map(categories, group => (
        <OptGroup label={group.name} key={`group-${group.id}`}>
          {_.map(group.categories, cat => (
            <Option value={cat.id} key={cat.id} name={cat.name}>
              {cat.name}
            </Option>
          ))}
        </OptGroup>
      ))
    );
  }

  render() {
    const {
      include_all,
      include_any,
      categories,
      showTextSelect,
      query,
      filterOption,
      ...other
    } = this.props;

    let SelectComponent = Select;

    if (showTextSelect) {
      SelectComponent = TextDropdownSelect;
    }

    return (
      <SelectComponent
        {...other}
        onSearch={this.searchManufacturers}
        optionFilterProp='name'
        clearable={true}
        notFoundContent={query ? 'No categories found' : 'Type to search for a category'}
      >
        {include_all && <Option value='all'>All Categories</Option>}
        {include_any && <Option value='any'>Any Category</Option>}
        {this.renderChildren()}
      </SelectComponent>
    );
  }
}

CategorySelect.propTypes = {
  parentOnly: PropTypes.bool,
  include_all: PropTypes.bool,
  include_any: PropTypes.bool,
  categories: PropTypes.object,
  query: PropTypes.object,
  showTextSelect: PropTypes.bool,
  filterOption: PropTypes.func
};

CategorySelect.defaultProps = {
  parentOnly: true
};

const mapStateToProps = (state, ownProps) => ({
  categories: getGroupedCategories(state, { parentOnly: ownProps.parentOnly })
});

const mapDispatchToProps = dispatch => ({
  categoryFetchAction: () => dispatch(categoriesFetch())
});

export default connect(mapStateToProps, mapDispatchToProps)(CategorySelect);
